import React from 'react'

import { TagItem } from '@cinch/oxd-components/product-card/src/components/tags/tags.component'
import Product from '@cinch/oxd-components/product-list-card/src'
import { getMake, getModel, getVehicleTags } from '@cinch/oxd-utils/manufacturers/src'

export type Location = Pick<Cinch.UserProfileRequest, 'latitude' | 'longitude' | 'location' | 'distance'>

export interface VehicleCardProps {
  isSaved: boolean
  isPending: boolean
  unavailable?: string
  isUnfavourited?: boolean
  linkToProductView?: boolean
  isAvailable?: boolean
  vehicle?: Cinch.DirectVehicleAdvertSummary
  id?: string
  onSave?: (newVal: boolean) => void
  isCinchStock?: boolean
}

const defaultVehicle = {
  imageCount: 0,
  make: '',
  selectedModel: '',
  distance: '',
  dealerTown: '',
  colour: '',
  dealershipName: '',
  doors: '',
  bodyType: '',
  engineSize: '',
  fuelType: '',
  mileage: '',
  price: 0,
  thumbnailUrl: '',
  transmissionType: '',
  trim: '',
  vehicleId: '0',
  vehicleYear: '',
  webDealerProfileId: 0,
  latitude: 0,
  longitude: 0,
  isDeliverable: false,
  isAvailable: false,
}

const VehicleCard: React.FC<VehicleCardProps> = ({ vehicle = defaultVehicle, id = '0', ...props }) => {
  const { vehicleId, price, trim, make, selectedModel } = vehicle
  const title = `${getMake(make)} ${getModel(make, selectedModel)}`
  const image: string =
    vehicle && vehicle.thumbnailUrl ? vehicle.thumbnailUrl.replace(/0-(.*)-thumbnail\.([a-z]+)$/, '1-$1.$2') : ''
  const tags: TagItem[] = vehicle ? getVehicleTags(vehicle) : []

  return (
    <Product
      id={vehicleId || id}
      price={price}
      image={image}
      title={title}
      subtitle={trim}
      tags={tags}
      isCinchStock={true}
      {...props}
    />
  )
}

export default VehicleCard
